export default "__VITE_PUBLIC_ASSET__442a1a02__"